import { UK_EU_BRANDS_FREE_SHIPPING_START_MILLIS } from "@faire/web-api--source/indigofair/settings/UK_EU_BRANDS_FREE_SHIPPING_START_MILLIS";

import { getSettingValueAndAssign } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingUkEuBrandsFreeShippingStartMillis = (): number =>
  getSettingValueAndAssign(UK_EU_BRANDS_FREE_SHIPPING_START_MILLIS, 0);
